export default __webpack_public_path__ + "static/media/zioapp.736265f4.png";